import React, {useEffect, useRef} from "react";
import {connect, useDispatch} from "react-redux";
import {getBankDetails, getUser} from "./redux/profile.action";
import {globalStyle} from "../../assets";
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  View,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import {SafeAreaView} from "react-native-safe-area-context";
import KycDetails from "./childComponents/KycDetails";
import AddBankDetails from "./childComponents/AddBankDetails";
import AddOnlyBankDetails from "./childComponents/AddOnlyBankDetails";
import KycConfigurable from "./childComponents/KycConfigurable";
import ApprovedKyc from "./childComponents/approvedKyc";
import {GlobalScreens, globalConfigurableData} from "../../utils/globalConstant";
import FastImage from "../../common/FastImage";
import {Icon} from '@iconify/react';
import FormTextLabel from "../../commonComponents/FormTextLabel";
import {isMobile} from "../../utils/commonMethods";

const ManageKycBank = ({navigation, profileData, BankDetailsData, fetchRequest, route}) => {
  const dispatch = useDispatch();
  const scrollViewRef = useRef(null);
  const isD24 = route?.params?.isD24 || false;
  const isKycShow = profileData?.withdrawConfig?.pgArray?.includes("cashfree");

  useEffect(() => {
    dispatch(getUser());
    fetchRequest();
  }, []);

  useEffect(() => {
    if (route?.params?.showKYC && scrollViewRef.current) {
      // Scroll to KYC section with animation
      scrollViewRef.current.scrollTo({y: 0, animated: true});
    }
  }, [route?.params?.showKYC]);

  return (
    <SafeAreaView style={globalStyle.container}>
      <View style={styles.headerContainer}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}>
          <Icon 
            icon="tabler:arrow-left"
            style={styles.backIcon}
            color={globalConfigurableData.primaryTextColor1}
            width="24"
            height="24"
          />
        </TouchableOpacity>
        <FormTextLabel
          labelStyles={styles.headerTitle}
          label={"Manage KYC & Bank"}
        />
        <View style={styles.rightPlaceholder} />
      </View>
      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
        style={{flex: 1}}>
        <ScrollView 
          ref={scrollViewRef}
          style={{paddingHorizontal: 16}}>
          {isKycShow && GlobalScreens.Account.isKyc && (
            <>
              {profileData?.kycstatus !== "C" ? (
                <AddBankDetails bankDetails={BankDetailsData} />
              ) : BankDetailsData?.bankdetails ? (
                <KycDetails bankDetails={BankDetailsData} />
              ) : (
                <AddOnlyBankDetails kycDetails={profileData?.kycdetails} />
              )}
            </>
          )}
          {isD24 && (
            <>
              {profileData?.kycstatus !== "C" ? (
                <KycConfigurable />
              ) : (
                <ApprovedKyc />
              )}
            </>
          )}
        </ScrollView>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    height: 56,
    backgroundColor: globalConfigurableData.globalThemeColor,
    borderBottomWidth: 1,
    borderBottomColor: globalConfigurableData.borderColor,
  },
  backButton: {
    padding: 8,
    marginLeft: -8,
  },
  backIcon: {
    width: 24,
    height: 24,
  },
  headerTitle: {
    ...globalStyle.appFontSize18,
    color: globalConfigurableData.primaryTextColor1,
    flex: 1,
    textAlign: 'center',
    marginHorizontal: 16,
  },
  rightPlaceholder: {
    width: 24,
  },
});

const mapStateToProps = ({profile}) => ({
  BankDetailsData: profile.BankDetailsData,
  profileData: profile.profileData,
});

const mapDispatchToProps = dispatch => ({
  fetchRequest: () => {
    dispatch(getBankDetails());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageKycBank); 